/* eslint-disable */

import React from "react"
import PlayIcon from "../../assets/PlayIcon"

const FocusEpisodeS1 = ({ article, onClickPlay }) => {
  // Initialize focus articles metadata variables
  const focusSrc = article.node.videoUrl.value
  const focusEpisode = article.node.episode.value
  const focusBy = article.node.by.value
  const focusByImage = article.node.byImg.value

  const handleClickPlay = () => {
    onClickPlay(focusSrc.replace("https://vimeo.com/", ""))
  }

  return (
    <div className="episode-item" onClick={handleClickPlay}>
      <div className="image-container">
        <img src={article.node.image.src} />
        <div className="play-container">
          <div id="inline" className="play-button x-y-center" />
        </div>
      </div>
      <div className="data">
        <div className="episode">{focusEpisode}</div>
        <h3 className="font-black">{article.node.title}</h3>
        <p className="article-blurp">{article.node.excerpt}</p>
        <div className="md:hidden absolute">
          <PlayIcon />
        </div>
        <div className="episode-by hidden md:block">
          <img src={focusByImage}></img>
          <p className="name-by font-bold">{focusBy}</p>
        </div>
      </div>
    </div>
  )
}

export default FocusEpisodeS1
